import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from 'vue';

import * as JobSiteService from '@/service/jobSite.service';

import { JobSite } from '@/types/JobSite';


export default /*#__PURE__*/_defineComponent({
  __name: 'JobsiteAutocomplete',
  props: {
  initialSearch: {
    type: String,
    default: '',
  },
  customerId: {
    type: String,
    required: false,
  },
  required: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ['selected'],
  setup(__props, { emit }) {

const props = __props





const jobsiteSearch = ref<string>(props.initialSearch);
const allJobsites = ref<JobSite[]>([]);
const isJobsiteLoading = ref<boolean>(false);
const selectedJobsite = ref<JobSite | null>(null);

const filteredJobsites = computed(() => {
  if (!jobsiteSearch.value) return allJobsites.value;

  const searchTerm = jobsiteSearch.value.toLowerCase();
  const jobsites = allJobsites.value.filter(site => {
    const address = site.address?.toLowerCase() || '';
    const street = site.street?.toLowerCase() || '';
    const city = site.city?.toLowerCase() || '';
    const nickname = site.nickname?.toLowerCase() || '';
    return (
      address.includes(searchTerm) ||
      street.includes(searchTerm) ||
      city.includes(searchTerm) ||
      nickname.includes(searchTerm)
    );
  });
  return jobsites;
});

function onTyping(value: string) {
  jobsiteSearch.value = value;
  if (!value) {
    selectedJobsite.value = null;
  }
}

async function fetchJobsites() {
  if (!props.customerId) return;

  isJobsiteLoading.value = true;
  try {
    const sites = await JobSiteService.getByCustomerId(props.customerId);
    allJobsites.value = sites;
  } catch (e: unknown) {
    allJobsites.value = [];
    if (e instanceof Error) {
      console.error('Error fetching job sites:', e.message);
    }
  } finally {
    isJobsiteLoading.value = false;
  }
}

// Watch for changes in customerId prop
watch(
  () => props.customerId,
  () => {
    fetchJobsites();
  },
  { immediate: true }
);

// Watch for changes in initialSearch prop
watch(
  () => props.initialSearch,
  newValue => {
    jobsiteSearch.value = newValue;
  }
);

function emitSelected(jobSite: JobSite | null) {
  if (!jobSite) {
    selectedJobsite.value = null;
    emit('selected', null);
    return;
  }

  emit('selected', jobSite);
}

return { __sfc: true,props, emit, jobsiteSearch, allJobsites, isJobsiteLoading, selectedJobsite, filteredJobsites, onTyping, fetchJobsites, emitSelected }
}

})